export const filter = (
  params: URLSearchParams,
  f: (key: string, value: string) => boolean
) => {
  const newParams = new URLSearchParams();
  const entries = Array.from(params);
  entries.forEach(([key, value]) => {
    if (f(key, value)) {
      newParams.append(key, value);
    }
  });
  return newParams;
};

export const merge = (...params: URLSearchParams[]) => {
  const map = new Map(
    params.reduce((acc: [string, string][], params) => {
      acc.push(...Array.from(params.entries()));
      return acc;
    }, [])
  );
  const newParams = new URLSearchParams();
  const mapEntries = Array.from(map.entries());
  mapEntries.forEach(([key, value]) => {
    newParams.append(key, value);
  });
  return newParams;
};

type Stringlike = string | number | boolean | Date | null;

interface ParamsObject {
  [key: string]: Stringlike;
}

export const from = (obj: ParamsObject) => {
  const entries = Object.keys(obj).map(
    (key: string): [string, Stringlike] => [key, obj[key]]
  );
  const params = entries.reduce((params, [key, value]) => {
    params.append(key, String(value));
    return params;
  }, new URLSearchParams());
  return params;
};

const URLSearchParamsUtils = {
  filter,
  merge,
  from
};

export default URLSearchParamsUtils;
